import Map from 'ol/Map';
import View from 'ol/View';
import { projection, matrixIds } from './Projection';

export const getMap = function (target, layers, center, zoom) {
  return new Map({
    target,
    layers,
    view: new View({
      center: center,
      extent: [420000, 6025000, 905000, 6450000],
      zoom: zoom,
      minResolution: 0.1,
      maxResolution: 819.2,
      maxZoom: matrixIds.length + 4,
      enableRotation: false,
      projection: projection,
    }),
  });
};
